/**
 * Counter component
 * @returns <Counter />
 */

const Counter = ({ initial, onAdd, onDecrease }) => {

    return (
        <div className="box-with-border counter --cart">
            <span className="decrement" onClick={onDecrease}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_244_17027)">
                        <path d="M19 13H5V11H19V13Z" fill="#323232" />
                    </g>
                </svg>
            </span>

            <p className="box-with-border__label">
                {initial}
            </p>

            <span className="increment" onClick={onAdd}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_244_16868)">
                        <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#323232" />
                    </g>
                </svg>
            </span>
        </div>
    )
}

const CounterCart = ({ initial, onAdd, onDecrease }) => {

    return (
        <div className="box-with-border counter --cart">
            <span className="decrement" onClick={onDecrease}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_244_17027)">
                        <path d="M19 13H5V11H19V13Z" fill="#323232" />
                    </g>
                </svg>
            </span>

            <p className="box-with-border__label">
                {initial}
            </p>

            <span className="increment" onClick={onAdd}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_244_16868)">
                        <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#323232" />
                    </g>
                </svg>
            </span>
        </div>
    )
}

export {
    Counter,
    CounterCart
}